(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-perfume-bundle"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('perfume-bundle')) {

    class PerfumeBundle extends HTMLElement {

      connectedCallback() {

        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        this.discount =
          Number(this.dataset.discount || 0);

        this.currency =
          this.dataset.currency || 'USD';

        this.addUrl =
          this.dataset.addUrl;

        this.cartUrl =
          this.dataset.cartUrl;

        this.addButton =
          this.querySelector('[data-add-bundle]');

        this.message =
          this.querySelector('[data-message]');


        this
          .querySelectorAll('[data-variant-select]')
          .forEach((select) => {

            select.addEventListener(
              'change',
              () => {

                this.updateCardFromSelect(select);

                this.updateTotals();

              }
            );

          });


        if (this.addButton) {

          this.addButton.addEventListener(
            'click',
            () => this.addBundle()
          );

        }


        this.updateTotals();

      }


      updateCardFromSelect(select) {

        const card =
          select.closest('[data-product-card]');

        const option =
          select.options[select.selectedIndex];


        if (!card || !option) return;


        card.dataset.currentVariant =
          option.value;

        card.dataset.currentPrice =
          option.dataset.price || '0';

        card.dataset.currentAvailable =
          option.dataset.available || 'false';


        const priceElement =
          card.querySelector('[data-card-price]');


        if (priceElement) {

          priceElement.textContent =
            this.formatMoney(
              Number(option.dataset.price || 0)
            );

        }

      }


      getItems() {

        return Array.from(
          this.querySelectorAll(
            '[data-product-card][data-configured="true"]'
          )
        ).map((card) => ({

          id:
            Number(
              card.dataset.currentVariant || 0
            ),

          price:
            Number(
              card.dataset.currentPrice || 0
            ),

          available:
            card.dataset.currentAvailable === 'true'

        }));

      }


      updateTotals() {

        const items =
          this.getItems();


        const validCount =
          items.length >= 2 &&
          items.length <= 3;


        const allAvailable =
          items.every(
            (item) =>
              item.id &&
              item.available
          );


        const regularTotal =
          items.reduce(
            (sum, item) =>
              sum + item.price,
            0
          );


        const savings =
          Math.round(
            regularTotal *
            (this.discount / 100)
          );


        const bundleTotal =
          Math.max(
            0,
            regularTotal - savings
          );


        const regularEl =
          this.querySelector(
            '[data-regular-total]'
          );

        const savingsEl =
          this.querySelector(
            '[data-saving-total]'
          );

        const bundleEl =
          this.querySelector(
            '[data-bundle-total]'
          );

        const buttonPriceEl =
          this.querySelector(
            '[data-button-price]'
          );


        if (regularEl) {

          regularEl.textContent =
            this.formatMoney(
              regularTotal
            );

        }


        if (savingsEl) {

          savingsEl.textContent =
            this.formatMoney(
              savings
            );

        }


        if (bundleEl) {

          bundleEl.textContent =
            this.formatMoney(
              bundleTotal
            );

        }


        if (buttonPriceEl) {

          buttonPriceEl.textContent =
            validCount
              ? this.formatMoney(bundleTotal)
              : '';

        }


        if (this.addButton) {

          this.addButton.disabled =
            !validCount ||
            !allAvailable;

        }


        if (
          items.length &&
          !allAvailable
        ) {

          this.setMessage(
            'One of the selected options is sold out.'
          );

        }

        else if (!validCount) {

          this.setMessage(
            'Choose 2 or 3 perfumes for this bundle.'
          );

        }

        else {

          this.setMessage('');

        }

      }


      async addBundle() {

        const items =
          this.getItems();


        if (
          items.length < 2 ||
          items.length > 3
        ) {

          this.setMessage(
            'Choose 2 or 3 perfumes for this bundle.'
          );

          return;

        }


        if (
          items.some(
            (item) =>
              !item.id ||
              !item.available
          )
        ) {

          this.setMessage(
            'One or more selected products are unavailable.'
          );

          return;

        }


        const labelEl =
          this.addButton.querySelector(
            '[data-button-label]'
          );


        const originalLabel =
          labelEl
            ? labelEl.textContent
            : 'Add bundle';


        if (labelEl) {

          labelEl.textContent =
            'ADDING...';

        }


        this.addButton.disabled =
          true;


        this.setMessage('');


        try {

          const response =
            await fetch(
              this.addUrl,
              {

                method: 'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  Accept:
                    'application/json'

                },

                body:
                  JSON.stringify({

                    items:
                      items.map(
                        (item) => ({

                          id:
                            item.id,

                          quantity:
                            1

                        })
                      )

                  })

              }
            );


          const data =
            await response
              .json()
              .catch(() => ({}));


          if (!response.ok) {

            throw new Error(
              data.description ||
              data.message ||
              'Unable to add the bundle.'
            );

          }


          if (labelEl) {

            labelEl.textContent =
              'ADDED ✓';

          }


          this.setMessage(
            'Bundle added to cart.'
          );


          window.setTimeout(
            () => {

              window.location.href =
                this.cartUrl;

            },
            250
          );

        }

        catch (error) {

          if (labelEl) {

            labelEl.textContent =
              originalLabel;

          }


          this.addButton.disabled =
            false;


          this.setMessage(
            error.message ||
            'Something went wrong. Please try again.'
          );

        }

      }


      setMessage(text) {

        if (this.message) {

          this.message.textContent =
            text || '';

        }

      }


      formatMoney(cents) {

        try {

          return new Intl.NumberFormat(
            document.documentElement.lang ||
            'en',
            {

              style:
                'currency',

              currency:
                this.currency

            }
          ).format(
            Number(cents || 0) / 100
          );

        }

        catch (error) {

          return `${
            (
              Number(cents || 0) / 100
            ).toFixed(2)
          } ${this.currency}`;

        }

      }

    }


    customElements.define(
      'perfume-bundle',
      PerfumeBundle
    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oudware-fragrance-profile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initOudwareProfile = (section) => {
      if (!section || section.dataset.owProfileInit === 'true') return;
      section.dataset.owProfileInit = 'true';

      const tabs = Array.from(section.querySelectorAll('.ow-profile__nav-item'));
      const panels = Array.from(section.querySelectorAll('.ow-profile__panel'));

      if (!tabs.length || !panels.length) return;

      const activate = (name, focus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.panel === name;

          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');

          if (active && focus) tab.focus();
        });

        panels.forEach((panel) => {
          const active = panel.dataset.panelContent === name;

          if (active) {
            panel.hidden = false;

            requestAnimationFrame(() => {
              panel.classList.add('is-active');
            });
          } else {
            panel.classList.remove('is-active');
            panel.hidden = true;
          }
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activate(tab.dataset.panel);
        });

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== null) {
            event.preventDefault();
            activate(tabs[nextIndex].dataset.panel, true);
          }
        });
      });

      const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

      if (activeTab) activate(activeTab.dataset.panel);
    };

    const initAll = () => {
      document.querySelectorAll('.ow-profile').forEach(initOudwareProfile);
    };

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector
        ? event.target.querySelector('.ow-profile')
        : null;

      if (section) initOudwareProfile(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-product-shelf"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ow-shelf-scroll]');
    if (!button) return;
    const track = button.closest('.ow-shelf')?.querySelector('.ow-shelf__track');
    const card = track?.querySelector('.ow-shelf__card');
    if (!track || !card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: Number(button.dataset.owShelfScroll) * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
